import PropTypes from "prop-types"
import React, { useContext } from "react"

import Button from "src/components/Button"
import Chips from "src/components/Chips"

import { ManageItemsContext } from "./ManageItemsContainer"
import { UNCATEGORIZED_CATEGORY } from "./utils/uncategorized"

const ManageItemsFilters = ({ onClearAll }) => {
  const { categories, table } = useContext(ManageItemsContext)
  const { productCategories, missingBarcode, inventoryOnly, search } =
    table.filters

  const selectedCategories = categories
    .concat(UNCATEGORIZED_CATEGORY)
    .filter((category) => productCategories.includes(category.id))

  const removeCategory = (id) =>
    table.setFilter(
      "productCategories",
      productCategories.filter((categoryId) => categoryId !== id)
    )

  const hasActiveFilters =
    productCategories.length > 0 || missingBarcode || inventoryOnly || !!search

  return (
    <Chips>
      {selectedCategories.map((category) => (
        <Chips.Chip
          key={category.id}
          text={category.displayName}
          onClick={() => removeCategory(category.id)}
        />
      ))}
      {missingBarcode && (
        <Chips.Chip
          key="missing_barcode"
          text="No Barcode"
          onClick={() => table.setFilter("missingBarcode", false)}
        />
      )}
      {inventoryOnly && (
        <Chips.Chip
          key="inventory_only"
          text="Show inventory items"
          onClick={() => table.setFilter("inventoryOnly", false)}
        />
      )}
      <Button
        variant="ghost"
        small
        onClick={onClearAll}
        disabled={!hasActiveFilters}
      >
        Clear all filters
      </Button>
    </Chips>
  )
}

ManageItemsFilters.propTypes = {
  onClearAll: PropTypes.func.isRequired,
}

export default ManageItemsFilters
